// 全局请求拦截器
import router from '@/router'
import apiConfig from '@/config/api'

// 创建请求拦截器
const createRequestInterceptor = () => {
  // 请求拦截
  const requestInterceptor = (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    return config
  }

  // 响应拦截
  const responseInterceptor = (response) => {
    return response
  }

  // 错误拦截
  const errorInterceptor = (error) => {
    if (error.response) {
      const { status, data } = error.response
      
      switch (status) {
        case 401:
          // 未授权，清除本地存储并跳转到登录页
          console.log('Token已过期或无效，跳转到登录页')
          localStorage.removeItem('token')
          localStorage.removeItem('sessionId')
          localStorage.removeItem('username')
          localStorage.removeItem('userId')
          
          // 如果当前不在登录页，则跳转
          if (router.currentRoute.path !== '/login') {
            alert('登录已过期，请重新登录')
            router.push('/login')
          }
          break
          
        case 403:
          console.log('权限不足:', data.message || '没有权限访问该资源')
          break
          
        case 500:
          console.log('服务器错误:', data.message || '服务器内部错误')
          break
          
        default:
          console.log('请求失败:', data.message || '未知错误')
      }
    } else if (error.request) {
      // 网络错误
      console.log('网络错误，请检查网络连接')
    } else {
      // 其他错误
      console.log('请求配置错误:', error.message)
    }
    
    return Promise.reject(error)
  }

  return {
    requestInterceptor,
    responseInterceptor,
    errorInterceptor
  }
}

// 创建fetch包装器
const createFetchWrapper = () => {
  const { requestInterceptor, errorInterceptor } = createRequestInterceptor()
  
  return async (url, options = {}) => {
    try {
      // 构建完整URL
      const fullUrl = url.startsWith('http') ? url : `${apiConfig.baseURL}${url}`
      
      // 应用请求拦截器
      const interceptedOptions = requestInterceptor(options)
      
      // 发送请求
      const response = await fetch(fullUrl, interceptedOptions)
      
      // 检查响应状态
      if (!response.ok) {
        const error = new Error(`HTTP ${response.status}`)
        error.response = {
          status: response.status,
          data: await response.json().catch(() => ({ message: '响应解析失败' }))
        }
        throw error
      }
      
      // 解析JSON响应
      const data = await response.json()
      return { data }
    } catch (error) {
      // 应用错误拦截器
      errorInterceptor(error)
      throw error
    }
  }
}

// 创建request对象，提供类似axios的API
const createRequest = () => {
  const fetchWrapper = createFetchWrapper()
  
  return {
    async get(url, config = {}) {
      return await fetchWrapper(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...config.headers
        },
        ...config
      })
    },
    
    async post(url, data, config = {}) {
      return await fetchWrapper(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...config.headers
        },
        body: JSON.stringify(data),
        ...config
      })
    },
    
    async put(url, data, config = {}) {
      return await fetchWrapper(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...config.headers
        },
        body: JSON.stringify(data),
        ...config
      })
    },
    
    async delete(url, config = {}) {
      return await fetchWrapper(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          ...config.headers
        },
        ...config
      })
    }
  }
}

// 导出拦截器和request对象
export const requestInterceptors = createRequestInterceptor()
export const fetchWrapper = createFetchWrapper()
export const request = createRequest()

// 默认导出request对象
export default request
